import { render, staticRenderFns } from "./TeacherDataCenterLayout.vue?vue&type=template&id=546f26a7&scoped=true&"
import script from "./TeacherDataCenterLayout.vue?vue&type=script&lang=js&"
export * from "./TeacherDataCenterLayout.vue?vue&type=script&lang=js&"
import style0 from "./TeacherDataCenterLayout.vue?vue&type=style&index=0&id=546f26a7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546f26a7",
  null
  
)

export default component.exports